import styled from "styled-components";

export const Container = styled.div``;

export const Content = styled.div`
  width: 100%;
  height: auto;
  display: flex;
  flex-direction: column;

  .row {
    width: 100%;
    height: 52px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 12px;

    .rowText {
      display: flex;
      flex-direction: column;

      .rowTitle {
        max-width: 300px;
        font-size: 12px;
        font-weight: 600;
        line-height: 16px;
        color: ${({ theme }) => theme.colors.surface.onSurface};
      }  
      
      .rowDescription {
        max-width: 300px;
        font-size: 12px;
        font-weight: 400;
        line-height: 16px;
        color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
      }  
    }

    .rowChange {
      display: flex;
      justify-content: flex-end;
      width: 202px;
      padding-left: 16px;
      font-weight: 600;
      line-height: 16px;
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
  
      .ant-select-selector, .select {
        width: 125px;
        border-radius: 6px !important;
        border: none;
      }
    }
  }
`;
